import { NavLink, Outlet } from "react-router-dom";
import { BRAND, DISCLAIMER } from "@shared/copy";

const nav = [
  ["/", "Home"],
  ["/explore", "Explore"],
  ["/catchments", "Catchments"],
  ["/models", "Models"],
  ["/studies", "Studies"],
  ["/events", "Events"],
  ["/assumptions", "Assumptions"],
  ["/insights", "Insights"],
  ["/about", "About"],
];

export function Shell() {
  return (
    <div className="site">
      <header className="header">
        <NavLink to="/" className="mark" aria-label="Floodplains home">
          {BRAND.mark}
        </NavLink>
        <div>
          <div className="brand-name">{BRAND.name}</div>
          <div className="brand-sub">Understand the system</div>
        </div>
        <nav className="nav">
          {nav.map(([to, label]) => (
            <NavLink key={to} to={to} end={to === "/"} className={({ isActive }) => (isActive ? "active" : "")}>
              {label}
            </NavLink>
          ))}
        </nav>
        <div className="header-right">
          <NavLink to="/workspace" className="font-data" style={{ fontSize: 12, color: "var(--ink-dim)", textDecoration: "none" }}>
            Workspace
          </NavLink>
          <a className="on-credit" href="https://onenetwork.ie" rel="noreferrer">
            <span className="on-dot" />
            <span>Powered by OneNetwork Core</span>
          </a>
        </div>
      </header>
      <div className="main">
        <Outlet />
      </div>
      <footer className="footer">
        <div className="wrap footer-grid">
          <div>
            <div className="brand-name">Floodplains</div>
            <p>Flood systems intelligence.</p>
            <p>
              <a className="on-credit" href="https://onenetwork.ie" rel="noreferrer">
                <span className="on-dot" />
                Built on OneNetwork
              </a>
            </p>
          </div>
          <div>
            <div className="kicker">Public</div>
            <p><a href="/explore">Explore</a></p>
            <p><a href="/catchments">Catchments</a></p>
            <p><a href="/methodology">Methodology</a></p>
            <p><a href="/data">Data</a></p>
          </div>
          <div>
            <div className="kicker">Network</div>
            <p><a href="/system/ross-river">Ross River</a></p>
            <p><a href="/compare">Compare models</a></p>
            <p><a href="https://floodplain.com.au">floodplain.com.au</a></p>
            <p><a href="/workspace">Workspace</a></p>
          </div>
        </div>
        <div className="wrap disclaimer">{DISCLAIMER}</div>
      </footer>
    </div>
  );
}
